import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=994c4be6&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994c4be6",
  null
  
)

export default component.exports